import { memo } from "react";
import { Button, PageHeader, useMediaQuery, useTheme } from "react-better-html";

import { useI18n } from "../../../utils/i18n";
import { useReduxState } from "../../../utils/hooks";

import Section from "../../../components/structure/Section";

function DeleteAccountSection() {
   const theme = useTheme();
   const mediaQuery = useMediaQuery();
   const { t } = useI18n();

   const isMobile = mediaQuery.size600;

   const firebaseUser = useReduxState((state) => state.user.firebaseUser);

   const deleteAccountButton = (
      <Button.destructive
         text={t((l) => l.pages.account.sections.deleteAccount.deleteButton)}
         href="/auth/delete-user"
      />
   );

   return firebaseUser ? (
      <Section
         backgroundColor={theme.colors.error + "20"}
         border={`solid ${theme.styles.borderWidth}px ${theme.colors.error}`}
      >
         <PageHeader
            title={t((l) => l.pages.account.sections.deleteAccount.title)}
            titleAs="h3"
            titleColor={theme.colors.error}
            description={t((l) => l.pages.account.sections.deleteAccount.description)}
            descriptionColor={theme.colors.error + "a0"}
            rightElement={!isMobile ? deleteAccountButton : undefined}
            marginBottom={isMobile ? theme.styles.space : 0}
         />

         {isMobile ? deleteAccountButton : undefined}
      </Section>
   ) : undefined;
}

export default memo(DeleteAccountSection);
